let $trainingFilters, $checkbox, $submitForm, serial, $removeFilter, $filterButton, $hasActiveCheckselect;


$(window).click(function(e) {
    let clickOnOptions = $(e.target).parents('.js-training-filter-list').length > 0;
    let clickOnButton = $(e.target).hasClass('js-training-filter-button');
    let clickOnButtonChildren = $(e.target).parents('.js-training-filter-button').length > 0
    let $form = $('.js-training-filter-form');
    $hasActiveCheckselect = $form.find('.is-active').length > 0;

    if ( $hasActiveCheckselect ) {
        if (clickOnOptions || clickOnButton || clickOnButtonChildren) {
            return;
        } else {
            $form.find('.is-active').removeClass('is-active');
        }
    }
});

$(document).ready(function($) {
    $trainingFilters = $('.js-training-filter');
    $checkbox = $('.js-training-filter-checkbox');
    $submitForm = $('.js-training-submit-form');
    $removeFilter = $('.js-remove-filter');
    $filterButton = $('.js-training-filter-button');
    serial = '?';
    
    setSelectedFilters();

    if ( $trainingFilters.length > 0 ) {
        $filterButton.on('click', function(e) {
            e.preventDefault();
            let $parent = $(this).parent();

            if ($parent.hasClass('is-active')) {
                $parent.removeClass('is-active');
            } else {
                $filterButton.parent().removeClass('is-active');
                $parent.addClass('is-active');
            }
        });
    }

    $submitForm.on('click', function(e) {
        e.preventDefault();
        getSelectedFilters();

        window.location.href = serial;
    })

    $removeFilter.on('click', function(e) {
        let clickedTaxonomy = e.currentTarget.dataset.filterkey;
        let clickedTerm = e.currentTarget.dataset.filtervalue;
        let $selectedTaxonomy = $(`[data-slug=${clickedTaxonomy}]`);
        
        $checkbox = $selectedTaxonomy.find(`#${clickedTerm}`);
        $checkbox.attr('checked', false)

        getSelectedFilters();
        window.location.href = serial;
    })

    function setSelectedFilters() {
        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);

        $($trainingFilters).each(function() {
            let parameters = urlParams.get($(this).attr('data-slug'));
            let $filter = $(this);

            if ( parameters ) {
                let parameterArray = parameters.split(',');
                parameterArray.forEach(function(parameter) {
                    $($filter).find(`#${parameter}`).attr('checked', 'checked')
                });
            }
        })
    }

    function getSelectedFilters() {

        $($trainingFilters).each(function() {
            let $checked = $(this).find(':checked');
            let checkedArray = [];

            $checked.each(function() {
                checkedArray.push($(this).attr('name'));
            });

            let $parameter_name = $(this).attr('data-slug');
            let parameter_value = checkedArray.toString();

            if (parameter_value) {
                let filter_serial = `&${$parameter_name}=${parameter_value}`;
                serial += filter_serial
            }
            
        });

    }

});
